var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountDropdownChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 38 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account-chevron-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 23,
    transform: "translate(-5947 -13173.45)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "account-chevron-filter-path",
    x: -7.142,
    y: 1.879,
    width: 52.284,
    height: 52.284,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#767983",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5947 13173.45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-chevron-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5947, -13173.45)",
    filter: "url(#account-chevron-filter-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20L0,20Z",
    transform: "translate(19 8.88) rotate(45)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-chevron-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,19.97,0,.023,19.936Z",
    transform: "translate(-5928 -13164.571) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.024-.012,20.042-.055l-1,1-18.019.09L1.077,18.9,0,19.973Z",
    transform: "translate(-5928 -13164.571) rotate(45)",
    fill: "#c4c5ca"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDropdownChevron);
export default __webpack_public_path__ + "static/media/account-dropdown-chevron.b7087e39.svg";
export { ForwardRef as ReactComponent };